(function () {
  let initialized = false;

  function initPricePerGramScript() {
    if (initialized) return;

    const productCards = document.querySelectorAll(".js-product-card");
    if (productCards.length === 0) return;

    initialized = true;

    const lang = document.documentElement.lang?.substring(0, 2) || navigator.language.substring(0, 2);

    const wordMap = { fr: "à partir de", en: "that’s", de: "entspricht" };
    const translatedWord = wordMap[lang] || "soit";

    productCards.forEach(function (pc_card) {
      const pc_select = pc_card.querySelector(".js-variant-select");
      const pc_priceEl = pc_card.querySelector(".js-price");
      const pc_compareEl = pc_card.querySelector(".js-compare-price");
      const pc_perGramEl = pc_card.querySelector(".js-price-per-gram");
      // const pc_discount = parseFloat(pc_card.dataset.discount || 0); // <-- no longer used
      const pc_variants = JSON.parse(pc_card.dataset.variants || "[]");

      function pc_formatPrice(pc_cents) {
        return (pc_cents / 100).toLocaleString(
          lang === "fr" ? "fr-FR" : lang === "de" ? "de-DE" : "en-US",
          { minimumFractionDigits: 2, maximumFractionDigits: 2 }
        ) + " €";
      }

      function pc_updatePrices(pc_option) {
        const pc_variantId = parseInt(pc_option.value);
        const pc_variant = pc_variants.find(v => v.id === pc_variantId);
        if (!pc_variant) return;

        const pc_basePrice = pc_variant.price;
        let pc_finalPrice = pc_basePrice; // <-- keep base price (no extra promo)
        let pc_showCompare = pc_variant.compare_at_price > pc_basePrice;

        if (pc_priceEl) pc_priceEl.textContent = pc_formatPrice(pc_finalPrice);
        if (pc_compareEl) pc_compareEl.textContent = pc_showCompare ? pc_formatPrice(pc_variant.compare_at_price) : "";

        // €/g
        const pc_title = pc_option.textContent.toLowerCase();
        const pc_gramMatch = pc_title.match(/(\d+(?:[\.,]\d+)?)\s*g/);
        if (pc_gramMatch && pc_perGramEl) {
          const pc_grams = parseFloat(pc_gramMatch[1].replace(",", "."));
          if (pc_grams > 0) {
            const euroPrice = pc_finalPrice / 100;
            const pricePerGram = Math.ceil((euroPrice / pc_grams) * 100) / 100;
            pc_perGramEl.textContent = `${translatedWord} ${pricePerGram.toLocaleString(
              lang === "fr" ? "fr-FR" : lang === "de" ? "de-DE" : "en-US",
              { minimumFractionDigits: 2, maximumFractionDigits: 2 }
            )} €/g`;
          } else {
            pc_perGramEl.textContent = `${translatedWord} — /g`;
          }
        } else if (pc_perGramEl) {
          pc_perGramEl.textContent = `${translatedWord} — /g`;
        }
      }

      if (pc_select && pc_select.options.length > 0) {
        let selected = pc_select.options[pc_select.selectedIndex];
        if (!selected || selected.disabled) {
          selected = Array.from(pc_select.options).find(opt => !opt.disabled) || pc_select.options[0];
        }
        if (selected) pc_updatePrices(selected);
        pc_select.addEventListener("change", function () {
          pc_updatePrices(this.options[this.selectedIndex]);
        });
      } else {
        const hiddenInput = pc_card.querySelector('input[name="id"]');
        const variantId = hiddenInput?.value;
        const variant = pc_variants.find(v => v.id == variantId);
        if (variant) {
          const fakeOption = { value: variant.id, textContent: variant.title, disabled: !variant.available };
          pc_updatePrices(fakeOption);
        }
      }
    });
  }

  document.addEventListener("DOMContentLoaded", initPricePerGramScript);

  const observer = new MutationObserver(() => {
    if (!initialized) initPricePerGramScript();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();